// Автоскролл фрейма

document.addEventListener('DOMContentLoaded', () => {
  smoothScrollOnAppear({
    targetSelector: '.scroll-trigger',
    withTriggerElement: true,
    repeat: true,
  })
  smoothScrollOnAppear({ targetSelector: '.cases-cards' })
})

const animatedElements = new Set()

function smoothScrollOnAppear({ targetSelector, withTriggerElement = false, repeat = false }) {
  const targets = document.querySelectorAll(targetSelector) ?? []

  // Опции для IntersectionObserver
  const options = {
    root: null,
    rootMargin: `-${window.innerHeight / 2 - 10}px 0px`,
    threshold: 0,
  }

  // Функция для плавного скроллинга с кастомной длительностью
  function smoothScroll(element, target, duration) {
    const start = element.scrollTop
    // Реальная максимальная прокрутка
    const maxScroll = Math.max(0, element.scrollHeight - element.clientHeight)
    // Корректируем target, чтобы он не выходил за границы
    const adjustedTarget = Math.min(Math.max(0, target), maxScroll)
    const distance = adjustedTarget - start
    let startTime = null

    if (distance === 0) return // Если уже на месте, ничего не делаем

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime
      const timeElapsed = currentTime - startTime
      const progress = Math.min(timeElapsed / duration, 1)
      const position = easeInOutCubic(progress, start, distance)

      // Устанавливаем scrollTop с учетом границ
      element.scrollTop = Math.min(Math.max(0, position), maxScroll)

      if (timeElapsed < duration) {
        requestAnimationFrame(animation)
      }

      if (progress === 1) animatedElements.delete(element.dataset['frame'])
    }

    // Ease-in-out cubic функция
    function easeInOutCubic(t, b, c) {
      t *= 2
      if (t < 1) return (c / 2) * t * t * t + b
      t -= 2
      return (c / 2) * (t * t * t + 2) + b
    }

    if (animatedElements.has(element.dataset['frame'])) {
      return
    }

    animatedElements.add(element.dataset['frame'])
    requestAnimationFrame(animation)
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const frame = withTriggerElement ? entry.target.nextElementSibling : entry.target
        const scrollDuration = 3000
        const maxScroll = Math.max(0, frame.scrollHeight - frame.clientHeight)

        if (frame.scrollTop === 0 || frame.scrollTop < frame.scrollTop / 2) {
          smoothScroll(frame, maxScroll, scrollDuration)
        } else {
          // Сверху вниз
          smoothScroll(frame, 0, scrollDuration)
        }

        if (!repeat) {
          observer.unobserve(entry.target)
        }
      }
    })
  }, options)

  targets.forEach((target) => {
    observer.observe(target)
  })
}
